import PropTypes from "prop-types";
import styles from "./index.css";
import CategoryHeaderLinks from "../CategoryHeader/CategoryHeaderLinks";
import FeaturedCategoryHeaderHero from "./FeaturedCategoryHeaderHero";
import { CATEGORY_BANNER_ID } from "../constants";
import * as types from "../CategoryHeaderMedia/constants";

export const FeaturedCategoryHeader = ({
  hasHeaderLinks,
  category,
  mediaType,
  viewportCategory,
  scrollFunction,
  featuredHeaderData
}) => (
  <section
    id={CATEGORY_BANNER_ID}
    className={styles.wrapper}
    aria-label="category banner video"
  >
    <div className={styles.textWrapper}>
      <FeaturedCategoryHeaderHero
        category={category}
        mediaType={mediaType}
        viewportCategory={viewportCategory}
        scrollFunction={scrollFunction}
        featuredHeaderData={featuredHeaderData}
      />
      {hasHeaderLinks && <CategoryHeaderLinks />}
    </div>
  </section>
);

FeaturedCategoryHeader.propTypes = {
  category: PropTypes.shape({
    headerBody: PropTypes.string,
    headerTitle: PropTypes.string
  }).isRequired,
  mediaType: PropTypes.oneOf(Object.values(types)).isRequired,
  hasHeaderLinks: PropTypes.bool.isRequired,
  viewportCategory: PropTypes.string.isRequired,
  scrollFunction: PropTypes.func.isRequired,
  featuredHeaderData: PropTypes.shape({
    app: PropTypes.shape({
      imageUrl: PropTypes.string,
      videoAssetId: PropTypes.string
    }),
    displayText: PropTypes.string,
    isEnabled: PropTypes.bool,
    web: PropTypes.shape({
      imageUrl: PropTypes.string,
      videoAssetId: PropTypes.string
    })
  })
};

export default FeaturedCategoryHeader;
